const selectedFocusName = (stockFocus) => (
  String(stockFocus || '').trim() || 'your selected Stock Focus'
);
const allStocks = (stockFocus) => stockFocus === 'ALL_STOCKS';

export const stockSearchPlaceholder = ({ practiceSetup, stockFocus }) => (
  practiceSetup
    ? allStocks(stockFocus) ? 'Ticker or company name' : `Ticker or company name within ${selectedFocusName(stockFocus)}`
    : 'Enter stock symbol or name (e.g., AAPL or Apple)...'
);

export const stockCandidateSummary = ({ total, visible, stockFocus }) => (
  `${Number(total || 0).toLocaleString()} ${allStocks(stockFocus) ? 'supported stocks' : `${selectedFocusName(stockFocus)} candidates`}`
  + ` · Results: ${Number(visible || 0).toLocaleString()} shown`
);

export const unambiguousUsTickerCandidate = (query) => {
  const match = String(query || '').trim().match(/^([A-Za-z][A-Za-z0-9.-]{0,14})\s+US$/i);
  return match ? match[1].toUpperCase() : null;
};

export const stockSearchRecoveryMessage = ({ query, symbol, practiceSetup = true }) => (
  `No exact match for “${String(query || '').trim()}”. Showing supported ticker ${symbol}`
  + (practiceSetup ? '; select it below to add it to your bot.' : '.')
);

export const stockEmptyStateTitle = ({ practiceSetup, stockFocus }) => (
  practiceSetup
    ? allStocks(stockFocus) ? 'No matching supported stocks' : `No matching stocks in ${selectedFocusName(stockFocus)}`
    : 'No matching stocks'
);

export const stockEmptyStateDetail = ({ practiceSetup, stockFocus }) => (
  practiceSetup
    ? allStocks(stockFocus)
      ? 'Try another symbol or company name, or clear the search to browse all stocks supported by Pinngro.'
      : `This search only includes stocks that currently match your selected Stock Focus profile. Try another symbol or company name, clear the search to browse all ${selectedFocusName(stockFocus)} candidates, or change your Stock Focus profile for a different set of stocks.`
    : 'Check the symbol or company name, or clear the search to browse the full stock universe.'
);

export const stockEmptySearchMessage = ({ query, practiceSetup, stockFocus }) => {
  const value = String(query || '').trim();
  if (!value) return stockEmptyStateDetail({ practiceSetup, stockFocus });
  return practiceSetup
    ? `No supported stock found for “${value}”. ${stockEmptyStateDetail({ practiceSetup, stockFocus })}`
    : `No stock found for “${value}”. ${stockEmptyStateDetail({ practiceSetup, stockFocus })}`;
};

export const stockClearSearchLabel = ({ practiceSetup, stockFocus }) => (
  practiceSetup
    ? allStocks(stockFocus) ? 'Show all supported stocks' : `Show all ${selectedFocusName(stockFocus)} candidates`
    : 'Clear search'
);
